import * as api from '../util/apis';
import { ENV } from '../constants/Constants';
import * as utils from '../util/bellplus-utils';

export const getUserrDetails = async (userDetails: any): Promise<any> => {
	try {
		const resp: any = await api.getapiresponses(ENV.dev.user + '/' + userDetails);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const updateUserDetails = async (userDetails: any, requestData: any) => {
	try {
		const resp: any = await api.putapiresponses(
			ENV.dev.user + '/' + userDetails,
			requestData,
		);
		const userData: any = localStorage.getItem('userDetails');
		const userDetailsUpdated = JSON.parse(userData);
		const data = { ...userDetailsUpdated.data, ...requestData };
		const setUserData = { ...userDetailsUpdated, data };
		utils.setData('userDetails', setUserData);
		console.warn(setUserData);
		return Promise.resolve(resp);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const updateUserCredentials = async (requestData: any) => {
	try {
		const resp: any = await api.putapiresponses(
			ENV.dev.user + '/update-password',
			requestData,
			false,
		);
		const dataCredentials: any = localStorage.getItem('userCredentials');
		let userCredentials = JSON.parse(dataCredentials);
		userCredentials = {
			...userCredentials,
			password: requestData.password,
		};
		utils.setData('userCredentials', userCredentials);
		return Promise.resolve(resp);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const forgotPassword = async (requestData: any): Promise<any> => {
	try {
		const resp: any = await api.forgotPassword(
			ENV.dev.user + '/forgot-password',
			requestData,
		);
		return Promise.resolve(resp);
	} catch (error) {
		return Promise.reject(error);
	}
};
